function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data,
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get("quantity-selector")) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector(".qty");
      this.step = this.input.getAttribute("step");
      this.changeEvent = new Event("change", {
        bubbles: true,
      });
      // Create buttons
      this.subtract = this.querySelector(".minus");
      this.add = this.querySelector(".plus");

      // Add functionality to buttons
      this.subtract.addEventListener("click", () =>
        this.change_quantity(-1 * this.step)
      );
      this.add.addEventListener("click", () =>
        this.change_quantity(1 * this.step)
      );
    }
    connectedCallback() {
      this.classList.add("buttons_added");
      this.validateQtyRules();
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute("min") > quantity + change) {
        return;
      }
      if (this.input.getAttribute("max")) {
        if (this.input.getAttribute("max") < quantity + change) {
          return;
        }
      }
      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1);

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);

      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle("disabled", value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle("disabled", value >= max);
      }
    }
  }
  customElements.define("quantity-selector", QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {
  constructor(self) {
    this.submenu = self.parentNode.querySelector(".sub-menu");
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener("click", (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains("active")) {
      submenu.classList.add("active");
    } else {
      submenu.classList.remove("active");
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll(".thb-arrow");
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get("product-card")) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector(".product-card-swatches");
      this.image = this.querySelector(
        ".product-featured-image-link .product-primary-image"
      );
      this.additional_images = this.querySelectorAll(
        ".product-secondary-image"
      );
      this.additional_images_nav = this.querySelectorAll(
        ".product-secondary-images-nav li"
      );
      this.quick_add = this.querySelector(
        ".product-card--add-to-cart-button-simple"
      );
      this.size_options = this.querySelector(".product-card-sizes");
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
      if (this.size_options) {
        this.enableSizeOptions();
      }
    }
    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector(".product-featured-image-link");
      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains("hover")) {
            image.classList.remove("hover");
            if (nav.length) {
              nav[index].classList.remove("active");
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains("hover")) {
            selimg.classList.add("hover");
            if (nav.length) {
              nav[sel].classList.add("active");
            }
          }
        }
      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove("hover");
          if (nav.length) {
            nav[index].classList.remove("active");
          }
        });
      };
      if (image_container) {
        image_container.addEventListener("touchstart", mousemove, {
          passive: true,
        });
        image_container.addEventListener("touchmove", mousemove, {
          passive: true,
        });
        image_container.addEventListener("touchend", mouseleave, {
          passive: true,
        });
        image_container.addEventListener("mouseenter", mousemove, {
          passive: true,
        });
        image_container.addEventListener("mousemove", mousemove, {
          passive: true,
        });
        image_container.addEventListener("mouseleave", mouseleave, {
          passive: true,
        });
      }

      images.forEach(function (image) {
        window.addEventListener("load", (event) => {
          lazySizes.loader.unveil(image);
        });
      });
    }
    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll(".product-card-swatch"),
        org_srcset = image ? image.dataset.srcset : "";
      this.color_index = this.swatches.dataset.index;

      swatch_list.forEach((swatch, index) => {
        window.addEventListener("load", (event) => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });

        swatch.addEventListener("mouseover", () => {
          [].forEach.call(swatch_list, function (el) {
            el.classList.remove("active");
          });
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute("srcset", swatch.dataset.srcset);
            } else {
              image.setAttribute("srcset", org_srcset);
            }
          }
          if (this.size_options) {
            this.current_options[this.color_index] = swatch.querySelector(
              "span"
            ).innerText;
            this.updateMasterId();
          }
          swatch.classList.add("active");
        });
        swatch.addEventListener("click", function (evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }
    enableQuickAdd() {
      this.quick_add.addEventListener("click", this.quickAdd.bind(this));
    }
    enableSizeOptions() {
      let size_list = this.size_options.querySelectorAll(
          ".product-card-sizes--size"
        ),
        featured_image = this.querySelector(".product-featured-image"),
        has_hover = featured_image.classList.contains("thb-hover"),
        size_parent = this.size_options.parentElement;

      this.size_index = this.size_options.dataset.index;

      this.current_options = this.size_options.dataset.options.split(",");

      this.updateMasterId();

      size_parent.addEventListener(
        "mouseenter",
        () => {
          if (has_hover) {
            featured_image.classList.remove("thb-hover");
          }
        },
        {
          passive: true,
        }
      );
      size_parent.addEventListener(
        "mouseleave",
        () => {
          if (has_hover) {
            featured_image.classList.add("thb-hover");
          }
        },
        {
          passive: true,
        }
      );
      size_list.forEach((size) => {
        size.addEventListener("click", (evt) => {
          evt.preventDefault();

          if (size.classList.contains("is-disabled")) {
            return;
          }
          this.current_options[this.size_index] = size.querySelector(
            "span"
          ).innerText;
          this.updateMasterId();

          size.classList.add("loading");
          size.setAttribute("aria-disabled", true);
          const config = {
            method: "POST",
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              Accept: "application/javascript",
            },
          };
          let formData = new FormData();

          formData.append("id", this.currentVariant.id);
          formData.append("quantity", 1);
          formData.append(
            "sections",
            this.getSectionsToRender().map((section) => section.section)
          );
          formData.append("sections_url", window.location.pathname);

          config.body = formData;

          fetch(`${theme.routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                return;
              }
              this.renderContents(response);

              dispatchCustomEvent("cart:item-added", {
                product: response.hasOwnProperty("items")
                  ? response.items[0]
                  : response,
              });
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              size.classList.remove("loading");
              size.removeAttribute("aria-disabled");
            });
        });
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.current_options[index] === option;
          })
          .includes(false);
      });
      setTimeout(() => {
        this.setDisabled();
      }, 100);
    }
    getVariantData() {
      this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
    setDisabled() {
      const variant_data = this.getVariantData();

      if (variant_data) {
        if (this.currentVariant) {
          const selected_options = this.currentVariant.options.map(
            (value, index) => {
              return {
                value,
                index: `option${index + 1}`,
              };
            }
          );

          const available_options = this.createAvailableOptionsTree(
            variant_data,
            selected_options
          );

          const fieldset_options = Object.values(available_options)[
            this.size_index
          ];
          if (fieldset_options) {
            if (
              this.size_options.querySelectorAll(".product-card-sizes--size")
                .length
            ) {
              this.size_options
                .querySelectorAll(".product-card-sizes--size")
                .forEach((input, input_i) => {
                  input.classList.toggle(
                    "is-disabled",
                    fieldset_options[input_i].isUnavailable
                  );
                });
            }
          }
        } else {
          if (
            this.size_options.querySelectorAll(".product-card-sizes--size")
              .length
          ) {
            this.size_options
              .querySelectorAll(".product-card-sizes--size")
              .forEach((input, input_i) => {
                input.classList.add("is-disabled");
              });
          }
        }
      }
      return true;
    }
    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce(
        (options, variant) => {
          // Check each option group (e.g. option1, option2, option3) of the variant
          Object.keys(options).forEach((index) => {
            if (variant[index] === null) return;

            let entry = options[index].find(
              (option) => option.value === variant[index]
            );

            if (typeof entry === "undefined") {
              // If option has yet to be added to the options tree, add it
              entry = {
                value: variant[index],
                isUnavailable: true,
              };
              options[index].push(entry);
            }

            // Check how many selected option values match a variant
            const countVariantOptionsThatMatchCurrent = selected_options.reduce(
              (count, { value, index }) => {
                return variant[index] === value ? count + 1 : count;
              },
              0
            );

            // Only enable an option if an available variant matches all but one current selected value
            if (
              countVariantOptionsThatMatchCurrent >=
              selected_options.length - 1
            ) {
              entry.isUnavailable =
                entry.isUnavailable && variant.available
                  ? false
                  : entry.isUnavailable;
            }

            // Make sure if a variant is unavailable, disable currently selected option
            if (
              (!this.currentVariant || !this.currentVariant.available) &&
              selected_options.find(
                (option) =>
                  option.value === entry.value && index === option.index
              )
            ) {
              entry.isUnavailable = true;
            }

            // First option is always enabled
            if (index === "option1") {
              entry.isUnavailable =
                entry.isUnavailable && variant.available
                  ? false
                  : entry.isUnavailable;
            }
          });

          return options;
        },
        {
          option1: [],
          option2: [],
          option3: [],
        }
      );
    }
    // quickAdd(evt) {
    //   evt.preventDefault();
    //   if (this.quick_add.disabled) {
    //     return;
    //   }
    //   this.quick_add.classList.add("loading");
    //   this.quick_add.setAttribute("aria-disabled", true);

    //   const config = {
    //     method: "POST",
    //     headers: {
    //       "X-Requested-With": "XMLHttpRequest",
    //       Accept: "application/javascript",
    //     },
    //   };

    //   let formData = new FormData();

    //   formData.append("id", this.quick_add.dataset.productId);
    //   formData.append("quantity", 1);
    //   formData.append(
    //     "sections",
    //     this.getSectionsToRender().map((section) => section.section)
    //   );
    //   formData.append("sections_url", window.location.pathname);

    //   config.body = formData;

    //   fetch(`${theme.routes.cart_add_url}`, config)
    //     .then((response) => response.json())
    //     .then((response) => {
    //       if (response.status) {
    //         return;
    //       }
    //       this.renderContents(response);

    //       dispatchCustomEvent("cart:item-added", {
    //         product: response.hasOwnProperty("items")
    //           ? response.items[0]
    //           : response,
    //       });
    //     })
    //     .catch((e) => {
    //       console.error(e);
    //     })
    //     .finally(() => {
    //       this.quick_add.classList.remove("loading");
    //       this.quick_add.removeAttribute("aria-disabled");
    //     });

    //   return false;
    // }
    // getSectionsToRender() {
    //   return [
    //     {
    //       id: "Cart",
    //       section: "main-cart",
    //       selector: ".thb-cart-form",
    //     },
    //     {
    //       id: "Cart-Drawer",
    //       section: "cart-drawer",
    //       selector: ".cart-drawer",
    //     },
    //     {
    //       id: "cart-drawer-toggle",
    //       section: "cart-bubble",
    //       selector: ".thb-item-count",
    //     },
    //   ];
    // }
    // renderContents(parsedState) {
    //   this.getSectionsToRender().forEach((section) => {
    //     if (!document.getElementById(section.id)) {
    //       return;
    //     }
    //     const elementToReplace =
    //       document.getElementById(section.id).querySelector(section.selector) ||
    //       document.getElementById(section.id);
    //     elementToReplace.innerHTML = this.getSectionInnerHTML(
    //       parsedState.sections[section.section],
    //       section.selector
    //     );

    //     if (section.id === "Cart-Drawer") {
    //       document.getElementById("Cart-Drawer")?.notesToggle();
    //       document.getElementById("Cart-Drawer")?.removeProductEvent();
    //     }

    //     if (section.id === "Cart" && typeof Cart !== "undefined") {
    //       new Cart().renderContents(parsedState);
    //     }
    //   });

    //   if (document.getElementById("Cart-Drawer")) {
    //     document.getElementById("Cart-Drawer").classList.add("active");
    //     document.body.classList.add("open-cart");
    //     document.body.classList.add("open-cc");
    //     if (
    //       document
    //         .getElementById("Cart-Drawer")
    //         .querySelector(".product-recommendations--full")
    //     ) {
    //       document
    //         .getElementById("Cart-Drawer")
    //         .querySelector(".product-recommendations--full")
    //         .classList.add("active");
    //     }
    //     dispatchCustomEvent("cart-drawer:open");
    //   }
    // }
    // getSectionInnerHTML(html, selector = ".shopify-section") {
    //   return new DOMParser()
    //     .parseFromString(html, "text/html")
    //     .querySelector(selector).innerHTML;
    // }

    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add("loading");
      this.quick_add.setAttribute("aria-disabled", true);

      const config = {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/javascript",
        },
      };

      let formData = new FormData();

      formData.append("id", this.quick_add.dataset.productId);
      formData.append("quantity", 1);
      formData.append(
        "sections",
        this.getSectionsToRender().map((section) => section.section)
      );
      formData.append("sections_url", window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent("cart:item-added", {
            product: response.hasOwnProperty("items")
              ? response.items[0]
              : response,
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove("loading");
          this.quick_add.removeAttribute("aria-disabled");
        });

      return false;
    }
    getSectionsToRender() {
      return [
        {
          id: "Cart",
          section: "main-cart",
          selector: ".thb-cart-form",
        },
        {
          id: "Cart-Drawer",
          section: "cart-drawer",
          selector: ".cart-drawer",
        },
        {
          id: "cart-drawer-toggle",
          section: "cart-bubble",
          selector: ".thb-item-count",
        },
      ];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section) => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) ||
          document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );

        if (section.id === "Cart-Drawer") {
          document.getElementById("Cart-Drawer")?.notesToggle();
          document.getElementById("Cart-Drawer")?.removeProductEvent();
        }

        if (section.id === "Cart" && typeof Cart !== "undefined") {
          new Cart().renderContents(parsedState);
        }
      });

      // Display a message instead of opening the cart drawer
      this.showAddedToCartMessage();

      // Dispatch event for other components that might need to know an item was added
      dispatchCustomEvent("cart:message-only-added");
    }
    getSectionInnerHTML(html, selector = ".shopify-section") {
      return new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selector).innerHTML;
    }
    showAddedToCartMessage() {
      // Create or display your message here
      // Example implementation:
      const messageContainer = document.createElement("div");
      messageContainer.className = "cart-add-message";
      messageContainer.innerHTML = "Item added to cart";
      messageContainer.style.position = "fixed";
      messageContainer.style.bottom = "20px";
      messageContainer.style.right = "20px";
      messageContainer.style.padding = "10px 20px";
      messageContainer.style.backgroundColor = "#4CAF50";
      messageContainer.style.color = "white";
      messageContainer.style.borderRadius = "4px";
      messageContainer.style.zIndex = "9999";

      document.body.appendChild(messageContainer);

      // Remove after 3 seconds
      setTimeout(() => {
        document.body.removeChild(messageContainer);
      }, 3000);
    }
  }
  customElements.define("product-card", ProductCard);
}

/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get("side-panel-close")) {
  class PanelClose extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector(".click-capture");

      this.onClick = (e) => {
        let panel = document.querySelectorAll(".side-panel.active");
        if (panel.length) {
          this.close_panel(e, panel[0]);
        }
      };
      // Add functionality to buttons
      this.addEventListener("click", this.onClick.bind(this));
      document.addEventListener("panel:close", this.onClick.bind(this));
      if (!this.cc.hasAttribute("initialized")) {
        this.cc.addEventListener("click", this.onClick.bind(this));
        this.cc.setAttribute("initialized", "");
      }
    }
    close_panel(e, panel) {
      if (e) {
        e.preventDefault();
      }
      if (!panel) {
        panel = e?.target.closest(".side-panel.active");

        if (!panel) {
          return;
        }
      }
      if (
        panel.classList.contains("product-drawer") ||
        document.body.classList.contains("open-quick-view")
      ) {
        this.close_quick_view();
      } else if (panel.classList.contains("cart-drawer")) {
        if (panel.querySelector(".product-recommendations--full")) {
          if (!document.body.classList.contains("open-quick-view")) {
            panel
              .querySelector(".product-recommendations--full")
              .classList.remove("active");
          }
        }
        if (window.innerWidth < 1069) {
          if (!document.body.classList.contains("open-quick-view")) {
            panel.classList.remove("active");
            document.body.classList.remove("open-cc");
            document.body.classList.remove("open-cart");
          } else {
            this.close_quick_view();
          }
        } else {
          if (panel.querySelector(".product-recommendations--full")) {
            if (!document.body.classList.contains("open-quick-view")) {
              setTimeout(() => {
                panel.classList.remove("active");
                document.body.classList.remove("open-cc");
                document.body.classList.remove("open-cart");
              }, 500);
            } else {
              this.close_quick_view();
            }
          } else {
            panel.classList.remove("active");
            document.body.classList.remove("open-cc");
            document.body.classList.remove("open-cart");
          }
        }
      } else {
        panel.classList.remove("active");
        document.body.classList.remove("open-cc");
      }
    }
    close_quick_view() {
      let panel = document.getElementById("Product-Drawer");

      if (panel.querySelector(".product-quick-images--container")) {
        panel
          .querySelector(".product-quick-images--container")
          .classList.remove("active");
      }
      if (window.innerWidth < 2500) {
        panel.classList.remove("active");
        if (
          !document.body.classList.contains("open-cart") ||
          !document.body.classList.contains("open-quick-view")
        ) {
          document.body.classList.remove("open-cc");
        }
        document.body.classList.remove("open-quick-view");
      } else {
        if (panel.querySelector(".product-quick-images--container")) {
          setTimeout(() => {
            panel.classList.remove("active");
            if (
              !document.body.classList.contains("open-cart") ||
              !document.body.classList.contains("open-quick-view")
            ) {
              document.body.classList.remove("open-cc");
            }
            document.body.classList.remove("open-quick-view");
            panel.querySelector("#Product-Drawer-Content").innerHTML = "";
          }, 500);
        }
      }
    }
  }
  customElements.define("side-panel-close", PanelClose);

  document.addEventListener("keyup", (e) => {
    if (e.code) {
      if (e.code.toUpperCase() === "ESCAPE") {
        dispatchCustomEvent("panel:close");
      }
    }
  });
}
/**
 *  @class
 *  @function CartDrawer
 */
if (!customElements.get("cart-drawer")) {
  class CartDrawer extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      let button = document.getElementById("cart-drawer-toggle");

      // Add functionality to buttons
      button.addEventListener("click", (e) => {
        e.preventDefault();
        document.body.classList.add("open-cc");
        document.body.classList.add("open-cart");
        this.classList.add("active");
        this.focus();
        setTimeout(() => {
          this.querySelector(".product-recommendations--full")?.classList.add(
            "active"
          );
        });
        console.log("Red");
        dispatchCustomEvent("cart-drawer:open");
      });

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      document.addEventListener("cart:refresh", (event) => {
        this.refresh();
      });

      this.addEventListener("change", this.debouncedOnChange.bind(this));

      this.notesToggle();
      this.removeProductEvent();
    }
    onChange(event) {
      if (event.target.classList.contains("qty")) {
        this.updateQuantity(event.target.dataset.index, event.target.value);
      }
    }
    removeProductEvent() {
      let removes = this.querySelectorAll(".remove");

      removes.forEach((remove) => {
        remove.addEventListener("click", (event) => {
          this.updateQuantity(event.target.dataset.index, "0");

          event.preventDefault();
        });
      });
    }
    getSectionsToRender() {
      return [
        {
          id: "Cart-Drawer",
          section: "cart-drawer",
          selector: ".cart-drawer",
        },
        {
          id: "cart-drawer-toggle",
          section: "cart-bubble",
          selector: ".thb-item-count",
        },
      ];
    }
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selector).innerHTML;
    }
    notesToggle() {
      let notes_toggle = document.getElementById("order-note-toggle");

      if (!notes_toggle) {
        return;
      }

      notes_toggle.addEventListener("click", (event) => {
        notes_toggle.nextElementSibling.classList.add("active");
      });
      notes_toggle.nextElementSibling
        .querySelectorAll(".button, .order-note-toggle__content-overlay")
        .forEach((el) => {
          el.addEventListener("click", (event) => {
            notes_toggle.nextElementSibling.classList.remove("active");
            this.saveNotes();
          });
        });
    }
    saveNotes() {
      fetch(`${theme.routes.cart_update_url}.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: `application/json`,
        },
        body: JSON.stringify({
          note: document.getElementById("mini-cart__notes").value,
        }),
      });
    }
    updateQuantity(line, quantity) {
      this.querySelector(`#CartDrawerItem-${line}`)?.classList.add(
        "thb-loading"
      );
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });

      dispatchCustomEvent("line-item:change:start", {
        quantity: quantity,
      });
      this.querySelector(".product-recommendations--full")?.classList.remove(
        "active"
      );

      fetch(`${theme.routes.cart_change_url}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: `application/json`,
        },
        ...{
          body,
        },
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document
                .getElementById(section.id)
                .querySelector(section.selector) ||
              document.getElementById(section.id);

            if (parsedState.sections) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            }
          });

          this.removeProductEvent();
          this.notesToggle();
          dispatchCustomEvent("line-item:change:end", {
            quantity: quantity,
            cart: parsedState,
          });

          this.querySelector(`#CartDrawerItem-${line}`)?.classList.remove(
            "thb-loading"
          );
        });
    }
    refresh() {
      this.querySelector(".product-recommendations--full")?.classList.remove(
        "active"
      );
      let sections = "cart-drawer,cart-bubble";
      fetch(`${window.location.pathname}?sections=${sections}`)
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document
                .getElementById(section.id)
                .querySelector(section.selector) ||
              document.getElementById(section.id);

            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState[section.section],
              section.selector
            );
          });

          this.removeProductEvent();
          this.notesToggle();
        });
    }
  }
  customElements.define("cart-drawer", CartDrawer);
}

/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    window.addEventListener("load", () => {
      document.querySelectorAll(".resize-select").forEach(_this.resizeSelect);
    });

    // delegated listener on change
    document.body.addEventListener("change", (e) => {
      if (
        e.target.matches(".resize-select") &&
        e.target.offsetParent !== null
      ) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener("resize.resize-select", function () {
      document.querySelectorAll(".resize-select").forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement("option");
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement("select"),
      offset = 13;
    tempSelect.style.visibility = "hidden";
    tempSelect.style.position = "fixed";
    tempSelect.appendChild(tempOption);
    if (
      sel.classList.contains("thb-language-code") ||
      sel.classList.contains("thb-currency-code") ||
      sel.classList.contains("facet-filters__sort")
    ) {
      offset = 2;
    }
    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + offset}px`;
    }
    tempSelect.remove();
  }
}

if (typeof SelectWidth !== "undefined") {
  new SelectWidth();
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document
      .querySelectorAll(".thb-widget-title.collapsible")
      .forEach((button) => {
        button.addEventListener("click", (e) => {
          button.classList.toggle("active");
        });
      });
  }
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get("quick-view")) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.drawer = document.getElementById("Product-Drawer");
      this.body = document.body;
      document.addEventListener("DOMContentLoaded", function () {
        document.querySelectorAll(".blinky").forEach(function (element) {
          setInterval(() => {
            element.classList.toggle("hidden");
          }, 600);
        });
      });
      this.addEventListener("click", this.setupEventListener.bind(this));
    }
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace("//", "/");
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains("loading")) {
        return;
      }
      this.classList.add("loading");
      fetch(href, {
        method: "GET",
      })
        .then((response) => {
          this.classList.remove("loading");
          return response.text();
        })
        .then((text) => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector("#Product-Drawer-Content").innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);
        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {
        this.drawer.querySelector(
          "#Product-Drawer-Content"
        ).innerHTML = sectionInnerHTML;

        let js_files = this.drawer
          .querySelector("#Product-Drawer-Content")
          .querySelectorAll("script");

        if (js_files.length > 0) {
          var head = document.getElementsByTagName("head")[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement("script");
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        this.body.classList.add("open-cc");
        this.body.classList.add("open-quick-view");
        this.drawer.classList.add("active");

        this.drawer.querySelector(".side-panel-close").focus();

        dispatchCustomEvent("quick-view:open", {
          productUrl: href,
          productHandle: productHandle,
        });
        addIdToRecentlyViewed(productHandle);
      }
    }
  }
  customElements.define("quick-view", QuickView);
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get("side-panel-content-tabs")) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll("button");
      this.panels = this.parentElement.querySelectorAll(
        ".side-panel-content--tab-panel"
      );
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() {}
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener("click", (e) => {
          this.toggleActiveClass(i);
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove("tab-active");
      });
      this.buttons[i].classList.add("tab-active");

      this.panels.forEach((panel) => {
        panel.classList.remove("tab-active");
      });
      this.panels[i].classList.add("tab-active");
    }
  }

  customElements.define("side-panel-content-tabs", SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get("collapsible-row")) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector("details");
      this.summary = this.querySelector("summary");
      this.content = this.querySelector(".collapsible__content");

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      this.querySelector("summary").addEventListener("click", (e) =>
        this.onClick(e)
      );
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = "hidden";
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate(
        {
          // Set the keyframes from the startHeight to endHeight
          height: [startHeight, endHeight],
        },
        {
          duration: 250,
          easing: "ease",
        }
      );

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => (this.isClosing = false);
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${
        this.summary.offsetHeight + this.content.offsetHeight
      }px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate(
        {
          // Set the keyframes from the startHeight to endHeight
          height: [startHeight, endHeight],
        },
        {
          duration: 400,
          easing: "ease-out",
        }
      );
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => (this.isExpanding = false);
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = "";
    }
  }
  customElements.define("collapsible-row", CollapsibleRow);
}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {
  if (!handle) {
    let product = document.querySelector(".thb-product-detail");

    if (product) {
      handle = product.dataset.handle;
    }
  }
  if (!handle) {
    return;
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem("recently-viewed");
    if (recentIds != "undefined" && recentIds != null) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem(
      "recently-viewed",
      JSON.stringify(window.recentlyViewedIds)
    );
  }
}

document.addEventListener("DOMContentLoaded", () => {
  if (typeof FooterMenuToggle !== "undefined") {
    new FooterMenuToggle();
  }
});

// document.addEventListener('DOMContentLoaded', function () {
//   const addToCartButtons = document.querySelectorAll('.js-add-to-cart');
//   const productDrawer = document.getElementById('Product-Drawer');
//   const closeButtons = document.querySelectorAll('.side-panel-close');

//   // Close drawer functionality
//   closeButtons.forEach(button => {
//     button.addEventListener('click', function() {
//       productDrawer.classList.remove('active');
//     });
//   });

//   // Add to cart functionality
//   addToCartButtons.forEach((button) => {
//     button.addEventListener('click', function () {
//       const variantId = button.getAttribute('data-variant-id');

//       if (!variantId) {
//         console.error('Variant ID is missing');
//         return;
//       }

//       // Show loading state
//       button.classList.add('loading');

//       // Add product to cart
//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ id: variantId, quantity: 1 }),
//       })
//         .then((res) => res.json())
//         .then((data) => {
//           // Remove loading state
//           button.classList.remove('loading');

//           if (data.status && data.status !== 200) {
//             console.error('Error adding to cart:', data);
//             return;
//           }

//           console.log('Product added to cart:', data);

//           // Change button text to "Added"
//           const buttonText = button.querySelector('.product-card--add-to-cart-text');
//           buttonText.textContent = 'Added';

//           // Optional: Update cart count or open cart drawer if it exists
//           const cartDrawer = document.getElementById('Cart-Drawer');
//           if (cartDrawer) {
//             cartDrawer.classList.add('active');
//           }
//         })
//         .catch((error) => {
//           console.error('Error:', error);
//           button.classList.remove('loading');
//         });
//     });
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  var opencertificate_modalBtn = document.querySelectorAll(
      ".certificate_modal-open"
    ),
    certificate_modals = document.querySelectorAll(".certificate_modal"),
    closecertificate_modalBtn = document.querySelectorAll(
      ".certificate_modal-close"
    );
  // Function to handle modal state
  function handleModalState(modal, isOpening) {
    if (isOpening) {
      modal.classList.add("open");
      document.body.classList.add("body--overflow-hidden");
      document.body.classList.add("has-modal-open");
    } else {
      modal.classList.remove("open");
      document.body.classList.remove("body--overflow-hidden");
      // Check if any modals are still open
      var anyModalOpen = document.querySelector(".certificate_modal.open");
      if (!anyModalOpen) {
        document.body.classList.remove("has-modal-open");
      }
    }
  }
  // Open modal
  opencertificate_modalBtn.forEach(function (item) {
    item.addEventListener("click", function () {
      var modalId = this.getAttribute("data-certificate_modal-id"),
        modal = document.getElementById(modalId);
      handleModalState(modal, true);
    });
  });
  // Close modal
  closecertificate_modalBtn.forEach(function (item) {
    item.addEventListener("click", function () {
      var modal = item.closest(".certificate_modal");
      handleModalState(modal, false);
    });
  });
  // Close modal when clicking outside
  document.addEventListener("click", function (event) {
    certificate_modals.forEach(function (modal) {
      if (
        modal.classList.contains("open") &&
        !event.target.closest(".certificate_modal-content") &&
        !event.target.closest(".certificate_modal-open")
      ) {
        handleModalState(modal, false);
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var buttons = document.querySelectorAll("a.modal-button");
  var modals = document.querySelectorAll(".modal-ingradient");
  var closeButtons = document.querySelectorAll(".close1");
  const addToCartSticky = document.querySelector(".product-add-to-cart-sticky");

  buttons.forEach(function (button) {
    button.addEventListener("click", function (event) {
      event.preventDefault();
      var targetModal = document.querySelector(button.getAttribute("href"));
      if (targetModal) {
        targetModal.classList.add("active");
        document.body.classList.add("body--overflow-hidden");

        if (addToCartSticky) {
          addToCartSticky.classList.remove("sticky--visible");
        }
      }
    });
  });

  closeButtons.forEach(function (closeBtn) {
    closeBtn.addEventListener("click", function () {
      modals.forEach(function (modal) {
        modal.classList.remove("active");
      });
      document.body.classList.remove("body--overflow-hidden");
      if (addToCartSticky) {
        addToCartSticky.classList.add("sticky--visible");
      }
    });
  });

  window.addEventListener("click", function (event) {
    if (event.target.classList.contains("modal-ingradient")) {
      modals.forEach(function (modal) {
        modal.classList.remove("active");
      });
      document.body.classList.remove("body--overflow-hidden");
    }
  });
});

// // quick add in model popup
// document.getElementById('Product-Drawer-Content').addEventListener('click', async function(event) {
//   if (event.target.classList.contains('js-add-to-cart')) {
//     event.preventDefault();
//     const variantId = event.target.getAttribute('data-variant-id');
//     if (!variantId) {
//       console.error('Variant ID is missing');
//       return;
//     }

//     try {
//       // Show loading state (spinner only)
//       const button = event.target;
//       button.classList.add('loading');
//       button.setAttribute('disabled', 'disabled');

//       // 1. Add item to cart
//       const addResponse = await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ id: variantId, quantity: 1 })
//       });

//       const addData = await addResponse.json();
//       console.log("addData`1")
//       if (addData.status && addData.status !== 200) {
//         throw new Error('Failed to add to cart');
//       }

//       // 2. Close quick view
//       const closeButton = document.getElementById('Close-Quiick-view');
//       if (closeButton) closeButton.click();

//       // 3. Trigger cart refresh
//       document.dispatchEvent(new CustomEvent('cart:refresh'));

//       // 4. Open cart drawer
//       const cartDrawer = document.querySelector('cart-drawer, Cart-Drawer');
//       if (cartDrawer) {
//         cartDrawer.classList.add('active');
//         if (typeof cartDrawer.open === 'function') {
//           cartDrawer.open();
//         }
//       }

//     } catch (error) {
//       console.error('Error:', error);
//     } finally {
//       // Remove loading state
//       const button = event.target.closest('.js-add-to-cart');
//       if (button) {
//         button.classList.remove('loading');
//         button.removeAttribute('disabled');
//       }
//     }
//   }
// });

document
  .getElementById("Product-Drawer-Content")
  .addEventListener("click", async function (event) {
    if (event.target.classList.contains("js-add-to-cart")) {
      event.preventDefault();
      const variantId = event.target.getAttribute("data-variant-id");
      if (!variantId) {
        console.error("Variant ID is missing");
        return;
      }

      const button = event.target;
      button.classList.add("loading");
      button.setAttribute("disabled", "disabled");
      try {
        // Add item to cart
        const addResponse = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });
        if (!addResponse.ok) {
          throw new Error("Failed to add to cart");
        }

        // Close quick view
        const closeButton = document.getElementById("Close-Quiick-view");
        if (closeButton) closeButton.click();
        // Get updated cart data
        const cartResponse = await fetch("/cart.js");
        const cart = await cartResponse.json();

        // Update all cart count elements
        document
          .querySelectorAll(".cart-count, .js-cart-count")
          .forEach((el) => {
            el.textContent = cart.item_count;
          });

        // Trigger cart refresh for other components
        document.dispatchEvent(
          new CustomEvent("cart:refresh", { detail: { cart } })
        );

        // Open cart drawer
        const cartDrawer = document.querySelector("cart-drawer, Cart-Drawer");
        if (cartDrawer) {
          cartDrawer.classList.add("active");
          if (typeof cartDrawer.open === "function") {
            cartDrawer.open();
          }
          if (typeof cartDrawer.refresh === "function") {
            cartDrawer.refresh();
          }
        }
      } catch (error) {
        console.error("Error:", error);
        // Show error message to user
        const errorMessage = document.createElement("div");
        errorMessage.className = "error-message";
        errorMessage.textContent = "Could not add item to cart";
        button.parentNode.appendChild(errorMessage);
        setTimeout(() => errorMessage.remove(), 3000);
      } finally {
        button.classList.remove("loading");
        button.removeAttribute("disabled");
      }
    }
  });

document.addEventListener("DOMContentLoaded", function () {
  const stickyAddToCart = document.querySelector(".product-add-to-cart-sticky");
  const cartDrawer = document.querySelector("cart-drawer");

  if (!stickyAddToCart || !cartDrawer) {
    console.warn("Missing stickyAddToCart or cartDrawer element");
    return;
  }

  // Function to handle sticky cart visibility based on cart drawer state
  function updateStickyCartVisibility() {
    if (cartDrawer.classList.contains("active")) {
      stickyAddToCart.classList.remove("sticky--visible");
    } else {
      stickyAddToCart.classList.add("sticky--visible");
    }
  }

  // Initial check
  updateStickyCartVisibility();

  // Listen for close buttons
  document.addEventListener("click", function (e) {
    if (
      e.target.closest('cart-drawer [aria-label="Close"]') ||
      e.target.closest("cart-drawer .close-button")
    ) {
      setTimeout(updateStickyCartVisibility, 300);
    }
  });

  // Observe cartDrawer class changes
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.attributeName === "class") {
        updateStickyCartVisibility();
      }
    });
  }).observe(cartDrawer, { attributes: true });
});

document.addEventListener("DOMContentLoaded", function () {
  const stickyAddToCart = document.querySelector(".product-add-to-cart-sticky");

  // Only proceed if the sticky element exists on the page
  if (!stickyAddToCart) return;

  // Get the footer element
  const footer = document.querySelector("footer");
  let footerHeight = 0;
  let footerOffsetTop = 0;

  // Calculate footer position if it exists
  if (footer) {
    footerHeight = footer.offsetHeight;
    footerOffsetTop = footer.offsetTop;
  }

  // Function to handle scroll events
  function handleScroll() {
    const scrollPosition = window.scrollY;
    const windowHeight = window.innerHeight;
    const threshold = 150; // Adjust this value to control when the sticky appears
    const documentHeight = document.documentElement.scrollHeight;

    // Check if we're near the footer (with some buffer)
    const nearFooter =
      footer && scrollPosition + windowHeight > footerOffsetTop - 5;

    if (scrollPosition > threshold && !nearFooter) {
      stickyAddToCart.classList.add("sticky--visible");
    } else {
      stickyAddToCart.classList.remove("sticky--visible");
    }
  }

  // Initial check
  handleScroll();

  // Add scroll event listener
  window.addEventListener("scroll", handleScroll);

  // Recalculate footer position on resize (in case of layout changes)
  window.addEventListener("resize", function () {
    if (footer) {
      footerHeight = footer.offsetHeight;
      footerOffsetTop = footer.offsetTop;
    }
    handleScroll();
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Initialize cart drawer add to cart buttons
  const cartDrawerAddButtons = document.querySelectorAll(
    "#Cart-Drawer .js-add-to-cart"
  );
  const cartDrawer = document.getElementById("Cart-Drawer");
  // Function to update cart count display
  function updateCartCount() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const cartCountElements = document.querySelectorAll(".cart-count");
        cartCountElements.forEach((element) => {
          element.textContent = cart.item_count;
        });
      });
  }
  // Add to cart functionality for cart drawer
  cartDrawerAddButtons.forEach((button) => {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      const variantId = button.getAttribute("data-variant-id");
      // const productHandle = button.getAttribute('data-product-handle');
      if (!variantId) {
        console.error("Variant ID is missing");
        return;
      }
      // Show loading state
      const originalText = button.innerHTML;
      button.classList.add("loading");
      button.disabled = true;
      button.innerHTML = '<span class="loading-spinner"></span>';
      // Add product to cart
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
        }),
      })
        .then((response) => {
          console.log("adsd12123");
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          // Remove loading state
          button.classList.remove("loading");
          button.disabled = false;
          button.innerHTML = originalText;
          // Update button state to show success
          button.textContent = "Added";
          button.classList.add("added");
          // Update cart count
          updateCartCount();
          // Refresh cart drawer contents
          if (cartDrawer) {
            fetch("/?sections=cart-drawer")
              .then((response) => response.json())
              .then((data) => {
                const newCartDrawerHTML = new DOMParser().parseFromString(
                  data["cart-drawer"],
                  "text/html"
                );
                const newCartDrawerContent = newCartDrawerHTML.querySelector(
                  "#Cart-Drawer .side-panel-content"
                );
                if (newCartDrawerContent) {
                  cartDrawer.querySelector(".side-panel-content").innerHTML =
                    newCartDrawerContent.innerHTML;
                }
              });
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          button.classList.remove("loading");
          button.disabled = false;
          button.innerHTML = originalText;
          button.textContent = "Error - Try Again";
        });
    });
  });
});

function observeCartDrawer() {
  const cartDrawer = document.querySelector(".cart-drawer");
  if (!cartDrawer) return;

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === "class") {
        const youForgetTab = document.querySelector(
          '.tablinks[onclick*="YouForget"]'
        );
        const youForgetContent = document.getElementById("YouForget");

        if (!youForgetTab || !youForgetContent) return;

        if (cartDrawer.classList.contains("active")) {
          // Activate "YouForget" tab
          youForgetTab.classList.add("active");
          youForgetContent.style.display = "block";

          // Hide other tab contents
          document.querySelectorAll(".tabcontent").forEach((content) => {
            if (content.id !== "YouForget") content.style.display = "none";
          });

          // Deactivate other tab buttons
          document
            .querySelectorAll('.tablinks:not([onclick*="YouForget"])')
            .forEach((link) => {
              link.classList.remove("active");
            });
        } else {
          // Deactivate "YouForget" tab when drawer is closed
          youForgetTab.classList.remove("active");
        }
      }
    });
  });

  observer.observe(cartDrawer, {
    attributes: true,
    attributeFilter: ["class"],
  });
}

document.addEventListener("DOMContentLoaded", function () {
  observeCartDrawer();

  const tablinks = document.getElementsByClassName("tablinks");
  if (tablinks.length > 0) {
    tablinks[0].classList.add("active");

    const firstTabId = tablinks[0]
      .getAttribute("onclick")
      ?.match(/'([^']+)'/)?.[1];
    if (firstTabId) {
      const firstTabContent = document.getElementById(firstTabId);
      if (firstTabContent) {
        firstTabContent.style.display = "block";
      }
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const variantSelect = document.querySelector('[name="id"]');
  const sizeDisplay = document.querySelector("[data-variant-size-display]");

  if (!variantSelect || !sizeDisplay) return;

  // Watch for changes to the variant select
  const observer = new MutationObserver(function (mutations) {
    const variantId = variantSelect.value;
    const variantData = JSON.parse(
      document.querySelector('[type="application/json"]').textContent
    );
    const variant = variantData.find((v) => v.id == variantId);

    if (variant) {
      sizeDisplay.textContent = variant.options[0];
    }
  });

  observer.observe(variantSelect, { attributes: true });
});

// document.addEventListener("DOMContentLoaded", function () {
//   // function updateCartCountVisibility() {
//   //   const cartCountElements = document.querySelectorAll(".thb-item-count");
//   //   cartCountElements.forEach(function (element) {
//   //     // Check if the element exists
//   //     if (!element) return;

//   //     // Get the count value
//   //     const count = element.textContent.trim();

//   //     // If count is 0 or empty, hide it
//   //     if (count === "0" || count === "") {
//   //       element.style.display = "none";
//   //     } else {
//   //       element.style.display = "";
//   //     }
//   //   });
//   // }

//   // // Run on page load
//   // updateCartCountVisibility();

//   // Set up a MutationObserver to watch for changes to the cart count
//   const cartCountContainer = document.querySelector("#cart-drawer-toggle");
//   if (cartCountContainer) {
//     const observer = new MutationObserver(updateCartCountVisibility);
//     observer.observe(cartCountContainer, {
//       childList: true,
//       subtree: true,
//       characterData: true,
//     });
//   }

//   // Also attach to any cart update events
//   document.addEventListener("cart:updated", updateCartCountVisibility);
//   document.addEventListener("cart:item-added", updateCartCountVisibility);
//   document.addEventListener("cart:refresh", updateCartCountVisibility);

//   // Run every time the cart drawer is opened
//   document.addEventListener("cart-drawer:open", updateCartCountVisibility);
// });

const cartDrawer = document.querySelector(".side-panel.cart-drawer");
const themeHeader = document.getElementById("header");

if (cartDrawer && themeHeader) {
  let storedHeader = null; // Store the header before removal
  const headerParent = themeHeader.parentNode; // Store its original parent

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === "class") {
        const isActive = cartDrawer.classList.contains("active");
        if (isActive) {
          storedHeader = themeHeader;
          // themeHeader.remove();
        } else {
          console.log("Cart drawer closed - Re-inserting <theme-header>");
          if (storedHeader && !document.getElementById("header")) {
            headerParent.prepend(storedHeader);
          }
        }
      }
    });
  });

  observer.observe(cartDrawer, { attributes: true });
} else {
  console.warn("Cart drawer or header element not found");
}

document.addEventListener("DOMContentLoaded", function () {
  // Function to check if gift wrap is in cart
  function checkGiftWrapInCart() {
    return Array.from(document.querySelectorAll(".product-cart-item")).some(
      (item) => {
        const title = item
          .querySelector(".cart-product-link")
          ?.textContent?.trim();
        return (
          title && (title.includes("Gift Wrap") || title.includes("Gift-Wrap"))
        );
      }
    );
  }

  // Update all gift wrap buttons based on cart state
  function updateGiftWrapButtons() {
    const giftWrapInCart = checkGiftWrapInCart();
    const giftWrapButtons = document.querySelectorAll(
      'button[data-product-handle="gift-wrap"]'
    );

    giftWrapButtons.forEach((button) => {
      if (giftWrapInCart) {
        button.disabled = true;
        button.textContent = "Added ✓";
        button.classList.add("disabled");
      } else {
        button.disabled = false;
        button.textContent = button.getAttribute("data-original-text") || "ADD";
        button.classList.remove("disabled", "loading");
      }
    });
  }

  // Initialize buttons
  const giftWrapButtons = document.querySelectorAll(
    'button[data-product-handle="gift-wrap"]'
  );
  giftWrapButtons.forEach((button) => {
    button.setAttribute("data-original-text", button.textContent.trim());
    button.addEventListener("click", async function (e) {
      e.preventDefault();

      if (button.classList.contains("loading")) return;

      const productId = button.getAttribute("data-product-id");
      if (!productId) return;

      // Set adding state
      button.classList.add("loading");
      button.textContent = "Adding...";
      button.disabled = true;

      try {
        // Add to cart
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({
            id: productId,
            quantity: 1,
          }),
        });

        const data = await response.json();

        // Success - update button state
        // button.textContent = '';
        button.disabled = true;
        button.classList.remove("loading");

        // Dispatch custom event to update cart
        document.dispatchEvent(new CustomEvent("cart:refresh"));

        // Optionally open cart drawer
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) {
          cartDrawer.classList.add("active");
          document.body.classList.add("open-cc");
          document.body.classList.add("open-cart");
        }
      } catch (error) {
        console.error("Error:", error);
        button.textContent = "Error - Try Again";
        button.classList.remove("loading");

        // Reset button after delay
        setTimeout(() => {
          button.textContent = button.getAttribute("data-original-text");
          button.disabled = false;
        }, 2000);
      }
    });
  });

  // Update buttons when cart changes
  document.addEventListener("cart:refresh", function () {
    updateGiftWrapButtons; // Small delay to allow cart to update
  });

  // Initial check
  updateGiftWrapButtons();

  // Modify remove links to prevent page navigation
  document.addEventListener("click", function (e) {
    const removeLink = e.target.closest(".product-cart-item a.remove");
    if (removeLink) {
      e.preventDefault();
      const url = removeLink.getAttribute("href");

      const item = removeLink.closest(".product-cart-item");
      if (item) item.classList.add("loading");
      fetch(url)
        .then(() => {
          document.dispatchEvent(new CustomEvent("cart:refresh"));
        })
        .catch((error) => {
          console.error("Error:", error);
          if (item) item.classList.remove("loading");
        });
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const searchDrawer = document.getElementById("Search-Drawer");
  const header = document.getElementById("header");

  function toggleHeader() {
    if (searchDrawer.classList.contains("active")) {
      header.style.display = "none";
    } else {
      header.style.display = "";
    }
  }

  // Run once on load
  toggleHeader();

  // Create observer to watch for class changes
  const observer = new MutationObserver(function (mutationsList) {
    for (let mutation of mutationsList) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class"
      ) {
        toggleHeader();
      }
    }
  });

  observer.observe(searchDrawer, { attributes: true });
});

document.addEventListener("DOMContentLoaded", function () {
  // Use event delegation for dynamic elements
  document.body.addEventListener("click", function (event) {
    // Check if cart button was clicked
    if (event.target.closest(".cart-menu-button")) {
      event.preventDefault();
      event.stopPropagation();
      toggleCartPopup();
    }
    // Close popup if clicked outside
    else if (
      !event.target.closest(".cart-popup") &&
      document.querySelector(".cart-popup")?.style?.display === "block"
    ) {
      document.querySelector(".cart-popup").style.display = "none";
    }
  });

  // Toggle function with proper positioning
  function toggleCartPopup() {
    const cartPopup = document.querySelector(".cart-popup");
    const cartMenuButton = document.querySelector(".cart-menu-button");

    if (!cartPopup || !cartMenuButton) return;

    if (cartPopup.style.display !== "block") {
      // Calculate position
      const buttonRect = cartMenuButton.getBoundingClientRect();
      cartPopup.style.position = "absolute";
      cartPopup.style.top = `${buttonRect.bottom + window.scrollY}px`; // Account for scrolling
      cartPopup.style.right = `${window.innerWidth - buttonRect.right}px`;

      cartPopup.style.display = "block";
    } else {
      cartPopup.style.display = "none";
    }
  }

  // Re-open popup after cart updates (Shopify-specific)
  document.addEventListener("cart:updated", function () {
    // Small delay to allow Shopify's DOM update
    setTimeout(() => {
      const cartPopup = document.querySelector(".cart-popup");
      if (cartPopup && cartPopup.style.display === "none") {
        toggleCartPopup();
      }
    }, 300);
  });
});

// Use event delegation for the clear cart button
document.addEventListener("click", function (event) {
  // Find if the clicked element or any of its parents has the clearCart class
  let clickedElement = event.target;
  let clearCartButton = null;

  // Traverse up the DOM to find if we clicked on or within the clear cart button
  while (clickedElement && !clearCartButton) {
    if (
      clickedElement.classList &&
      clickedElement.classList.contains("clearCart")
    ) {
      clearCartButton = clickedElement;
    }
    clickedElement = clickedElement.parentElement;
  }

  // If we found the clear cart button, show the modal
  if (clearCartButton) {
    event.preventDefault();
    const clearCartModal = document.getElementById("clearCartModal");
    if (clearCartModal) {
      clearCartModal.style.display = "flex";
    }
  }

  // Handle cancel button click
  if (event.target.id === "cancelClearCart") {
    const clearCartModal = document.getElementById("clearCartModal");
    if (clearCartModal) {
      clearCartModal.style.display = "none";
    }
  }

  // Handle confirm button click
  if (event.target.id === "confirmClearCart") {
    const confirmButton = event.target;
    const clearCartModal = document.getElementById("clearCartModal");

    // Show loading state
    const originalText = confirmButton.textContent;
    confirmButton.disabled = true;
    confirmButton.innerHTML = '<span class="loading-spinner"></span>';

    // Use Shopify's fetch API to clear the cart
    fetch("/cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        // Cart cleared successfully
        console.log("Cart cleared:", data);

        // Update any cart counters on the page
        const cartCountElements = document.querySelectorAll(".cart-count");
        cartCountElements.forEach((element) => {
          element.textContent = "0";
        });

        // Reset button state
        confirmButton.disabled = false;
        confirmButton.innerHTML = originalText;

        // Close the modal
        if (clearCartModal) {
          clearCartModal.style.display = "none";
        }

        // If your theme has a refresh function, call it
        if (typeof window.refreshCart === "function") {
          window.refreshCart();
        }

        // Dispatch common cart update events that themes might listen for
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        document.dispatchEvent(new CustomEvent("cart:updated"));

        // Reload the page as a last resort if needed
        // Uncomment this if nothing else works
        // window.location.reload();
      })
      .catch((error) => {
        console.error("Error clearing cart:", error);
        // Reset button state
        confirmButton.disabled = false;
        confirmButton.innerHTML = originalText;

        // Show error message
        alert("There was an error clearing your cart. Please try again.");

        // Close the modal
        if (clearCartModal) {
          clearCartModal.style.display = "none";
        }
      });
  }
});

// Close modal when clicking outside
window.addEventListener("click", function (event) {
  const clearCartModal = document.getElementById("clearCartModal");
  if (clearCartModal && event.target === clearCartModal) {
    clearCartModal.style.display = "none";
  }
});

// Announce that the script has loaded
console.log("Cart clearing script loaded and active");

document.addEventListener("DOMContentLoaded", () => {
  const cartContainer = document.querySelector(".cart-drawer");
  // if (cartContainer) {
  //   cartContainer.addEventListener('click', async (event) => {
  //     if (event.target.classList.contains('copyBtn')) {
  //       const button = event.target;
  //       const couponCode = button.getAttribute('data-code');

  //       try {
  //         await navigator.clipboard.writeText(couponCode);
  //         const originalHTML = button.innerHTML;
  //         button.innerHTML = '<span class="copied-state">COPIED</span>';

  //         setTimeout(() => {
  //           button.innerHTML = originalHTML;
  //         }, 2000);
  //       } catch (err) {
  //         console.error('Failed to copy code:', err);
  //         button.innerHTML = '<span class="copied-state">Error!</span>';
  //       }
  //     }
  //   });
  // }
});

document.querySelector(".close-button").addEventListener("click", function () {
  const detailsElement = document.querySelector(".mobile-toggle-wrapper");
  detailsElement.classList.remove("active");
  document.body.classList.remove("overflow-hidden");
  detailsElement.removeAttribute("open");
});

document.addEventListener("DOMContentLoaded", function () {
  const benefitModal = document.getElementById("benefitModalbundlemobile");
  const stickyAddToCart = document.querySelector(".product-add-to-cart-sticky");
  const cartDrawer = document.querySelector("cart-drawer");

  // Function to handle sticky cart visibility based on modal and cart drawer states
  function updateStickyCartVisibility() {
    if (!stickyAddToCart) return; // Safeguard

    const isModalVisible = benefitModal?.style?.display === "block";
    const isCartDrawerActive = cartDrawer?.classList.contains("active");

    if (isModalVisible || isCartDrawerActive) {
      stickyAddToCart.classList.remove("sticky--visible");
    } else {
      stickyAddToCart.classList.add("sticky--visible");
    }
  }

  // Initial check
  updateStickyCartVisibility();

  // Observe the modal for style changes
  if (benefitModal) {
    new MutationObserver(function (mutations) {
      for (const mutation of mutations) {
        if (mutation.attributeName === "style") {
          updateStickyCartVisibility();
        }
      }
    }).observe(benefitModal, {
      attributes: true,
      attributeFilter: ["style"],
    });
  }

  // Observe the cart drawer for class changes
  if (cartDrawer) {
    new MutationObserver(function (mutations) {
      updateStickyCartVisibility();
    }).observe(cartDrawer, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const isMobile = window.innerWidth <= 768;
  if (isMobile) {
    const categoriesBlock = document.querySelector(".block.block-categories");
    const commentsBlock = document.querySelector(".block.block_comments");

    if (categoriesBlock && commentsBlock) {
      commentsBlock.parentNode.insertBefore(categoriesBlock, commentsBlock);
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  if (
    window.location.pathname === "/a/blog/" ||
    window.location.pathname === "/a/blog/media-press"
  ) {
    document.body.classList.add("custom-blog-page");
  }
});

document.addEventListener("DOMContentLoaded", function () {
  if (window.location.pathname === "/a/blog/media-press") {
    document.body.classList.add("custom-blog-page-media-press");
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const productSuggestion = document.querySelector(".product-suggestion");

  if (productSuggestion && productSuggestion.innerHTML.trim() === "&nbsp;") {
    fetch("/?section_id=product-suggestions")
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const sectionContent = doc.querySelector(
          "#shopify-section-product-suggestions"
        ).innerHTML;
        productSuggestion.innerHTML = sectionContent;
      })
      .catch((error) => console.error("Error loading products:", error));
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const shareContainer = document.querySelector(".share-elements");
  if (!shareContainer) return;

  const blogURL = window.location.href;

  const whatsappWrapper = document.createElement("div");
  whatsappWrapper.className = "mf-icon-wrapper mf-icon-whatsapp";
  whatsappWrapper.setAttribute(
    "onclick",
    `mfShareWindowOpen('${blogURL}', 'whatsapp')`
  );

  whatsappWrapper.innerHTML = `
      <div class="mf-icon" title="WhatsApp">
        <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="Share on WhatsApp">
      </div>
      <div class="mf-label">Share on WhatsApp</div>
    `;

  shareContainer.appendChild(whatsappWrapper);
});

// Optional: Extend mfShareWindowOpen to handle WhatsApp if needed
function mfShareWindowOpen(url, platform) {
  let shareUrl = "";

  switch (platform) {
    case "facebook":
      shareUrl =
        "https://www.facebook.com/sharer/sharer.php?u=" +
        encodeURIComponent(url);
      break;
    case "twitter":
      shareUrl =
        "https://twitter.com/intent/tweet?url=" + encodeURIComponent(url);
      break;
    case "pinterest":
      shareUrl =
        "https://pinterest.com/pin/create/button/?url=" +
        encodeURIComponent(url);
      break;
    case "linkedin":
      shareUrl =
        "https://www.linkedin.com/shareArticle?url=" + encodeURIComponent(url);
      break;
    case "whatsapp":
      shareUrl = "https://wa.me/?text=" + encodeURIComponent(url);
      break;
  }

  if (shareUrl) {
    window.open(shareUrl, "_blank", "width=600,height=400");
  }
}

function applyLabelsPlaceholdersWithStyle() {
  const mainForm = document.querySelector("#mf-comment-form-blog");
  const replyForm = document.querySelector("#c-replyform-comment form");

  const createLabel = (forId, text) => {
    const label = document.createElement("label");
    label.setAttribute("for", forId);
    label.textContent = text;
    label.style.display = "block";
    label.style.marginBottom = "5px";
    label.style.fontWeight = "600";
    label.style.fontSize = "14px";
    return label;
  };

  const applyField = (input, labelText, placeholderText) => {
    if (!input) return;

    // Add label
    const prev = input.previousElementSibling;
    if (!prev || prev.tagName !== "LABEL") {
      const label = createLabel(input.id || input.name, labelText);
      input.parentNode.insertBefore(label, input);
    }

    // Set placeholder text
    input.setAttribute("placeholder", placeholderText);

    // Add a class to apply red placeholder via CSS
    input.classList.add("red-placeholder");
  };

  if (mainForm) {
    applyField(
      mainForm.querySelector('input[name="author_nickname"]'),
      "Full Name",
      "Enter your full name"
    );
    applyField(
      mainForm.querySelector('input[name="author_email"]'),
      "Email Address",
      "Enter your email address"
    );
    applyField(
      mainForm.querySelector('textarea[name="text"]'),
      "Comment",
      "Write your comment..."
    );
  }

  if (replyForm) {
    applyField(
      replyForm.querySelector('input[name="author_nickname"]'),
      "Full Name",
      "Enter your full name"
    );
    applyField(
      replyForm.querySelector('input[name="author_email"]'),
      "Email Address",
      "Enter your email address"
    );
    applyField(
      replyForm.querySelector('textarea[name="text"]'),
      "Reply",
      "Write your reply..."
    );
  }
}

// Inject red placeholder CSS once
function injectPlaceholderStyle() {
  const style = document.createElement("style");
  style.textContent = `
      .red-placeholder::placeholder {
        color: #808080 !important;
        opacity: 1;
      }
    `;
  document.head.appendChild(style);
}

// Run logic with retry for dynamic forms
let attempts = 0;
const interval = setInterval(() => {
  injectPlaceholderStyle();
  applyLabelsPlaceholdersWithStyle();
  attempts++;
  if (attempts >= 10) clearInterval(interval);
}, 500);

// shopify-section shopify-section-group-header-group header-section is-sticky scrolling-up-header

document.addEventListener("DOMContentLoaded", function () {
  const toggleButton = document.getElementById("search-toggle");
  const searchDrawer = document.getElementById("Search-Drawer");

  if (toggleButton && searchDrawer) {
    toggleButton.addEventListener("click", function () {
      const isActive = searchDrawer.classList.toggle("active");

      if (isActive) {
        document.body.style.setProperty("overflow-y", "hidden", "important");
      } else {
        document.body.style.removeProperty("overflow-y");
      }
    });
  }
});

// Add event listener to the confirm button
// document
//   .querySelector(".cart-drawer-toggle.js-add-to-cart")
//   .addEventListener("click", async function (event) {
//     event.preventDefault();

//     // Get the button element
//     const button = event.target;

//     // Add loading state
//     button.classList.add("loading");
//     button.setAttribute("disabled", "disabled");

//     try {
//       // Prepare items array for the cart
//       const items = Object.entries(selectedVariants).map(([id, qty]) => ({
//         id: Number(id),
//         quantity: qty,
//       }));

//       // Check if any items are selected
//       if (items.length === 0) {
//         throw new Error("No items selected");
//       }

//       // Add items to cart
//       const addResponse = await fetch("/cart/add.js", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ items }),
//       });

//       if (!addResponse.ok) {
//         throw new Error("Failed to add to cart");
//       }

//       // Close the variant popup
//       closeVariantPopup();

//       // Get updated cart data
//       const cartResponse = await fetch("/cart.js");
//       const cart = await cartResponse.json();

//       // Update all cart count elements
//       document.querySelectorAll(".cart-count, .js-cart-count").forEach((el) => {
//         el.textContent = cart.item_count;
//       });

//       // Trigger cart refresh for other components
//       document.dispatchEvent(
//         new CustomEvent("cart:refresh", { detail: { cart } })
//       );

//       // Open cart drawer
//       const cartDrawer = document.querySelector("cart-drawer, Cart-Drawer");
//       if (cartDrawer) {
//         cartDrawer.classList.add("active");
//         if (typeof cartDrawer.open === "function") {
//           cartDrawer.open();
//         }
//         if (typeof cartDrawer.refresh === "function") {
//           cartDrawer.refresh();
//         }
//       }
//     } catch (error) {
//       console.error("Error:", error);
//       // Show error message to user
//       // const errorMessage = document.createElement("div");
//       // errorMessage.className = "error-message";
//       // errorMessage.textContent = "Could not add items to cart";
//       button.parentNode.appendChild(errorMessage);
//       setTimeout(() => errorMessage.remove(), 3000);
//     } finally {
//       // Reset loading state
//       button.classList.remove("loading");
//       button.removeAttribute("disabled");

//       // Clear selected variants
//       selectedVariants = {};
//     }
//   });

document.addEventListener("DOMContentLoaded", () => {
  const addToCartButtons = document.querySelectorAll(
    ".cart-drawer-toggle.js-add-to-cart"
  );

  if (!addToCartButtons.length) {
    console.warn("No .cart-drawer-toggle.js-add-to-cart buttons found.");
    return;
  }

  addToCartButtons.forEach((button) => {
    button.addEventListener("click", async function (event) {
      event.preventDefault();

      button.classList.add("loading");
      button.setAttribute("disabled", "disabled");

      try {
        const items = Object.entries(selectedVariants || {}).map(
          ([id, qty]) => ({
            id: Number(id),
            quantity: qty,
          })
        );

        if (items.length === 0) {
          throw new Error("No items selected");
        }

        const addResponse = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items }),
        });

        if (!addResponse.ok) {
          throw new Error("Failed to add to cart");
        }

        if (typeof closeVariantPopup === "function") {
          closeVariantPopup();
        }

        const cartResponse = await fetch("/cart.js");
        const cart = await cartResponse.json();

        const cartCountEls = document.querySelectorAll(
          ".cart-count, .js-cart-count"
        );
        if (cartCountEls.length) {
          cartCountEls.forEach((el) => (el.textContent = cart.item_count));
        }

        document.dispatchEvent(
          new CustomEvent("cart:refresh", { detail: { cart } })
        );

        const cartDrawer = document.querySelector("cart-drawer, Cart-Drawer");
        if (cartDrawer) {
          cartDrawer.classList.add("active");
          if (typeof cartDrawer.open === "function") cartDrawer.open();
          if (typeof cartDrawer.refresh === "function") cartDrawer.refresh();
        }
      } catch (error) {
        console.error("Error:", error);

        const errorMessage = document.createElement("div");
        errorMessage.className = "error-message";
        errorMessage.textContent = "Could not add items to cart";
        if (button.parentNode) {
          button.parentNode.appendChild(errorMessage);
          setTimeout(() => errorMessage.remove(), 3000);
        }
      } finally {
        button.classList.remove("loading");
        button.removeAttribute("disabled");
        selectedVariants = {};
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  let selectedVariants = {}; // already in your code

  // Handle plus/minus clicks
  document.querySelectorAll(".quantity-wrapper").forEach((wrapper) => {
    const minusBtn = wrapper.querySelector(".qty-btn.minus");
    const plusBtn = wrapper.querySelector(".qty-btn.plus");
    const qtyInput = wrapper.querySelector(".quantity-input");
    const variantId = qtyInput.dataset.variantId;

    // Initialize
    selectedVariants[variantId] = parseInt(qtyInput.value) || 1;

    minusBtn.addEventListener("click", function () {
      let current = parseInt(qtyInput.value) || 1;
      if (current > 1) {
        qtyInput.value = current - 1;
        selectedVariants[variantId] = current - 1;
      }
    });

    plusBtn.addEventListener("click", function () {
      let current = parseInt(qtyInput.value) || 1;
      qtyInput.value = current + 1;
      selectedVariants[variantId] = current + 1;
    });

    qtyInput.addEventListener("change", function () {
      let value = parseInt(qtyInput.value) || 1;
      if (value < 1) value = 1;
      qtyInput.value = value;
      selectedVariants[variantId] = value;
    });
  });
});

// document.addEventListener("DOMContentLoaded", function () {
//   // Get the form and buttons
//   const form = document.querySelector(".quantity-product-form");
//   const addToCartBtn = form.querySelector(".add-to-cart-btn");
//   const quantityInput = form.querySelector("#quantity-input");
//   const variantIdInput = form.querySelector('input[name="id"]');

//   // Quantity buttons functionality
//   const minusBtn = form.querySelector(".qty-btn.minus");
//   const plusBtn = form.querySelector(".qty-btn.plus");

//   minusBtn.addEventListener("click", function () {
//     const currentValue = parseInt(quantityInput.value);
//     if (currentValue > 1) {
//       quantityInput.value = currentValue - 1;
//     }
//   });

//   plusBtn.addEventListener("click", function () {
//     const currentValue = parseInt(quantityInput.value);
//     quantityInput.value = currentValue + 1;
//   });

//   // Form submission handler
//   form.addEventListener("submit", async function (e) {
//     e.preventDefault();

//     // Don't proceed if button is disabled (sold out)
//     if (addToCartBtn.disabled) return;

//     // Get form data
//     const formData = new FormData(form);
//     const quantity = parseInt(formData.get("quantity"));
//     const id = formData.get("id");

//     // Show loading state
//     const originalText = addToCartBtn.textContent;
//     addToCartBtn.textContent = "Adding...";
//     addToCartBtn.classList.add("adding");

//     try {
//       // Make AJAX request to add to cart
//       const response = await fetch("/cart/add.js", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           items: [
//             {
//               id: id,
//               quantity: quantity,
//             },
//           ],
//         }),
//       });

//       if (!response.ok) {
//         throw new Error("Failed to add item to cart");
//       }

//       const result = await response.json();

//       // Show success message
//       showNotification("Item added to cart successfully!", "success");

//       // Update cart count in the header if exists
//       updateCartCount();
//     } catch (error) {
//       console.error("Error adding to cart:", error);
//       showNotification(
//         "Failed to add item to cart. Please try again.",
//         "error"
//       );
//     } finally {
//       // Restore button state
//       addToCartBtn.textContent = originalText;
//       addToCartBtn.classList.remove("adding");
//     }
//   });
//   // Function to update cart count
//   function updateCartCount() {
//     // Fetch updated cart data
//     fetch("/cart.js")
//       .then((response) => response.json())
//       .then((cart) => {
//         // Update all elements with cart count classes
//         const cartCountElements = document.querySelectorAll(
//           ".cart-count, .js-cart-count"
//         );
//         cartCountElements.forEach((el) => {
//           el.textContent = cart.item_count;
//         });

//         // Dispatch event for other components to listen to
//         document.dispatchEvent(
//           new CustomEvent("cart:refresh", {
//             detail: { cart },
//           })
//         );
//       })
//       .catch((error) => {
//         console.error("Error fetching cart:", error);
//       });
//   }
// });

document.addEventListener("DOMContentLoaded", function () {
  // Get the form
  const form = document.querySelector(".quantity-product-form");

  // If form doesn't exist, stop running the script
  if (!form) {
    console.warn("No .quantity-product-form found on this page.");
    return;
  }

  const addToCartBtn = form.querySelector(".add-to-cart-btn");
  const quantityInput = form.querySelector("#quantity-input");
  const variantIdInput = form.querySelector('input[name="id"]');

  // Quantity buttons
  const minusBtn = form.querySelector(".qty-btn.minus");
  const plusBtn = form.querySelector(".qty-btn.plus");

  if (minusBtn && quantityInput) {
    minusBtn.addEventListener("click", function () {
      const currentValue = parseInt(quantityInput.value);
      if (currentValue > 1) {
        quantityInput.value = currentValue - 1;
      }
    });
  }

  if (plusBtn && quantityInput) {
    plusBtn.addEventListener("click", function () {
      const currentValue = parseInt(quantityInput.value);
      quantityInput.value = currentValue + 1;
    });
  }

  // Form submission
  form.addEventListener("submit", async function (e) {
    e.preventDefault();

    if (!addToCartBtn) return;
    if (addToCartBtn.disabled) return;

    const formData = new FormData(form);
    const quantity = parseInt(formData.get("quantity"));
    const id = formData.get("id");

    const originalText = addToCartBtn.textContent;
    addToCartBtn.textContent = "Adding...";
    addToCartBtn.classList.add("adding");

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: [{ id, quantity }],
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to add item to cart");
      }

      await response.json();
      showNotification("Item added to cart successfully!", "success");
      updateCartCount();
    } catch (error) {
      console.error("Error adding to cart:", error);
      showNotification(
        "Failed to add item to cart. Please try again.",
        "error"
      );
    } finally {
      addToCartBtn.textContent = originalText;
      addToCartBtn.classList.remove("adding");
    }
  });

  function updateCartCount() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const cartCountElements = document.querySelectorAll(
          ".cart-count, .js-cart-count"
        );
        cartCountElements.forEach((el) => {
          el.textContent = cart.item_count;
        });
        document.dispatchEvent(
          new CustomEvent("cart:refresh", { detail: { cart } })
        );
      })
      .catch((error) => {
        console.error("Error fetching cart:", error);
      });
  }
});

// document.addEventListener("DOMContentLoaded", function () {
//   var width = window.innerWidth;

//   if (width < 768) {
//     // Hide desktop slideshow and show mobile slideshow
//     document.getElementById(
//       "shopify-section-template--18139538391238__16479477632637c9a7"
//     ).innerHTML = "";
//     // Mobile slideshow remains visible (no action needed)
//   } else {
//     // Hide mobile slideshow and show desktop 
//     document.getElementById(
//       "shopify-section-template--18139538391238__slideshow_gNq3c8"
//     ).innerHTML = "";
//     // Desktop slideshow remains visible (no action needed)
//   }
// });

document.addEventListener("DOMContentLoaded", function () {
  var width = window.innerWidth;

  if (width < 768) {
    // Remove desktop slideshow from DOM
    var desktopElement = document.getElementById(
      "shopify-section-template--18375099842758__16479477632637c9a7"
    );
    if (desktopElement) {
      desktopElement.remove();
    }
  } else {
    // Remove mobile slideshow from DOM
    var mobileElement = document.getElementById(
      "shopify-section-template--18375099842758__slideshow_gNq3c8"
    );
    if (mobileElement) {
      mobileElement.remove();
    }
  }
});


